const id_trans_iteminlist = {
    "": "supervisi barang masuk",
    detail: "detail barang masuk",
    addsn: "Tambah Nomor Seri Barang",

    message: {
        upload: "Unduh contoh file EXCEL upload Serial Number",
        delete_title: "Apakah Anda yakin untuk menghapus data barang masuk?",
        delete_text: "Masukan alasan penghapusan data barang masuk",
    },

    error: {
        delete: "Gagal menghapus barang masuk",
    },

    success: {
        delete: "Berhasil menghapus barang masuk",
    },
}

export default id_trans_iteminlist;